export default "__VITE_ASSET__BYT2ap6w__"